import React, { useEffect, useState } from "react";
import SearchableSelect, { SearchableSelectOption } from ".";
import { apiV2 } from "@/api/axiosConfig";
import { PaginatedResponse } from "@/types/PaginatedResponse";
import { UserDataTypes } from "@/types/user-data-types";
import PeopleIcon from "@/assets/icons/icon-person.svg";

type UserSelectSingleV2Params = {
    clientID?: string | null;
    departmentID?: string | null;
    onSelectionChange?: (user: UserDataTypes | null) => void;
    user?: UserDataTypes | null;
    initialUserID?: string;
    disabled?: boolean;
    noClientOnChange?: boolean;
  };
  
  function UserSelectSingleV2({
    user,
    clientID,
    departmentID,
    onSelectionChange,
    initialUserID,
    disabled,
    noClientOnChange,
  }: UserSelectSingleV2Params) {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState<SearchableSelectOption<UserDataTypes>[]>([]);
    const [searchStr, setSearchStr] = useState("");
  
    const fetchUsers = async () => {
      setLoading(true);
      try {
        if (initialUserID != null && initialUserID !== "") {
            const initialUser = await apiV2.get<UserDataTypes>(`/users/${initialUserID}`);
            console.log("initialUser", initialUserID, initialUser);
            onSelectionChange?.(initialUser.data || null);
          }
          
  
        const res = await apiV2.get<PaginatedResponse<UserDataTypes>>("/users", {
          params: {
            clientID,
            departmentID,
            search: searchStr,
            rpp: 200,
          },
        });
        
        setOptions(
          res.data.items.map((u) => ({
            label: `${u.profile.firstName} ${u.profile.lastName}`,
            value: u,
            key: u.id,
          }))
        );
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
  
    useEffect(() => {
      fetchUsers();
    }, [clientID, departmentID, searchStr]);
  
    useEffect(() => {
      if (!noClientOnChange && onSelectionChange) {
        onSelectionChange(null);
      }
    }, [clientID, departmentID, noClientOnChange]);
  
    const onChange = (selected: SearchableSelectOption<UserDataTypes>[]) => {
      if (onSelectionChange) {
        onSelectionChange(selected.length > 0 ? selected[0].value : null);
      }
    };
  
    const onSearch = (value: string) => {
      setSearchStr(value);
    };
  
    return (
      <SearchableSelect
        icon={PeopleIcon}
        label="User"
        selected={
          user
            ? [{
                label: `${user.profile.firstName} ${user.profile.lastName}`,
                value: user,
                key: user.id,
              }]
            : []
        }
        search={true}
        multiple={false}
        options={options}
        localSearch={false}
        onChange={onChange}
        onSearch={onSearch}
        loading={loading}
        disabled={disabled}
      />
    );
  }
  
  export default UserSelectSingleV2;